/**
 * The editor works in a fixed pixel unit of **one inch**: 12 px = 1 ft. This is
 * anchored on the seed catalog (a `Round Table (60")` is radius 30 px = 30 in)
 * and on the venue spaces (1584×1224 px = 132×102 ft). Both the API and web use
 * these to convert between the stored pixel dimensions and human-facing feet.
 */
export const PIXELS_PER_FOOT = 12

/** Convert a measurement in feet to editor pixels. */
export function feetToPixels(feet: number): number {
  return feet * PIXELS_PER_FOOT
}

/** Convert editor pixels to feet. */
export function pixelsToFeet(pixels: number): number {
  return pixels / PIXELS_PER_FOOT
}
